export default __webpack_public_path__ + "static/media/page_not_found_image.df8f6982.png";